module.exports = __webpack_public_path__ + "img/nt107-01-81-1.prt.61715941.jpg";